import React from "react";
import GeneratingLoader from "../../components/ui/Loaders/GeneratingLoader";
import ProgressBar from "@components/ui/ProgressBar";
import { useSocket } from "context/SocketContext";
import { useTranslation } from "react-i18next";
import {
  mealSlide2,
  mealSlide3,
  mealSlide4,
  mealSlide5,
  mealSlide6,
  mealSlide7,
  mealSlide8,
} from "@utils/defaultImages";

const MealPlanLoader = (props) => {
  const { t } = useTranslation();
  const { dietProgress, clearDietProgress } = useSocket();

  const slides = [
    t("mealPlanLoader.link"),
    mealSlide2,
    mealSlide3,
    mealSlide4,
    mealSlide5,
    mealSlide6,
    mealSlide7,
    mealSlide8,
  ];

  const barConfig = {
    headingKey: "mealPlanLoader.mealPlanProgress",
    finalMessage: "Finalizing your meal plan!",
    statusMessages: {
      25: "Generating Your Personalized Meal Plan…",
      50: "Producing High-Quality Meal Images…",
      75: "Putting Together Your Step-by-Step Recipes…",
    },
  };

  return (
    <GeneratingLoader
      {...props}
      progressData={dietProgress}
      clearProgress={clearDietProgress}
      onComplete={props.fetchDietPlan}
      onFail={props.handleDietPlanFailed}
      slides={slides}
      translationBase="mealPlanLoader"
      progressBarConfig={barConfig}
    />
  );
};

export default MealPlanLoader;
